(function() {
	$('#product_img').lightSlider({
		item: 1,
		loop: false,
		slideMove: 2,
		easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
		loop: true,
		gallery: true,
		responsive: [{
			breakpoint: 767,
			settings: {
				gallery: false,
			}
		}]
	});
	tippy('#i-offer', {
		content: "Purchase any three products across the Vitabiotics range and get lowest priced one free.",
		maxWidth: '250px',
		trigger: 'click'
	});
	tippy('.i-reward', {
		content: "Earn reward points with every purchase and use to get money off on your next order with us.",
		maxWidth: '250px',
		trigger: 'click'
	});

	function priceCal(a) {
		var des = a - Math.floor(a, 2);
		if (des >= 0.5) {
			a = Math.ceil(a);
		} else {
			a = Math.floor(a);
		}
		return a;
	}
	angular.module('ngClick', function($location) {
		return {
			link: function(scope, elem, attrs) {
				if (attrs.href) {
					elem.on('touchend', function() {
						$location.path(attrs.href);
					});
				}
			},
			priority: 1
		};
	});
	app.controller('productCtr', ['$scope', '$sce', function($scope, $sce) {
		function renderHtml(str) {
			return $sce.trustAsHtml(str);
		}
		var myEl = angular.element(document.getElementById('#i-offer'));
		myEl.attr('aria-describedby', "tippy-8 tippy-10 tippy-12");
		$scope.iOffer = function() {
			myEl.attr('aria-describedby', "tippy-3 tippy-4 tippy-5 tippy-6 tippy-7 tippy-9 tippy-11");
		}
		$scope.iReward = function() {}
		$scope.threeforTwoOffer = true;
		var prxIcons = [];
		theme.prx.mainIcons.forEach((icon) => {
			if (icon.img && icon.img !== '&nbsp') {
				prxIcons.push({
					img: icon.img,
					title: icon.title
				});
			}
		});
		$scope.mainIcons = prxIcons;
		$scope.addQty = 1;
		$scope.purchaseBtnTxt = "ADD TO CART";
		$scope.product = theme.product;
		$scope.variants = $scope.product.variants;
		$scope.isSignleVariant = $scope.variants.length == 1 ? true : false;
		$scope.isSubscribed = false;
		$scope.isPurchase = true;
		$scope.currencySymbol = window.theme.currency;
		if (theme.product.type == "Liquid" || theme.product.type == "Drink" || theme.product.type == "Powder") {
			$scope.isSubscribedItem = false;
		} else {
			if (window.Shopify.country === 'GB') {
				if (theme.prx.sub) {
					$scope.isSubscribedItem = true;
				} else {
					$scope.isSubscribedItem = false;
				}
			} else {
				$scope.isSubscribedItem = false
			}
		}
		$scope.isSubscribedItem = false;
		$scope.selectTitle = '';
		if (!$scope.isSignleVariant) {
			var model = $scope.variants[0].option2;
			if (model) {
				$scope.selectTitle = 'flavour';
			} else {
				$scope.selectTitle = 'size';
			}
		}
		$scope.singlePurchaseSelected = true;
		$scope.subscribePurchaseSelected = false;
		$scope.selectedVariant = $scope.product.variants[0];
		var description = theme.product.description;
		$scope.available = $scope.selectedVariant.available;
		if (theme.prx.description) {
			if (theme.prx.description.length > 10) {
				description = theme.prx.description;
			}
		}
		$scope.disBadge = function() {
			var dis = Math.floor((($scope.selectedVariant.compare_at_price - $scope.selectedVariant.price) / $scope.selectedVariant.compare_at_price) * 100);
			return $sce.trustAsHtml(dis + '% <span class="discount_badge_off">OFF</span>');
		};
		$scope.subtitle = theme.prx.subtitle;
		$scope.description = renderHtml(description);
		$scope.product_info = renderHtml(theme.prx.info);
		$scope.product_nut_info = renderHtml(theme.prx.n);
		$scope.product_directions = renderHtml(theme.prx.d);
		$scope.product_ingredients = renderHtml(theme.prx.i);
		$scope.selectedPrice = $scope.selectedVariant.price;
		$scope.comparePrice = $scope.selectedVariant.compare_at_price;
		$scope.plus = function() {
			var max = 15;
			if ($scope.subscribePurchaseSelected) {
				max = 6;
			}
			if ($scope.addQty === max) {
				return;
			}
			$scope.addQty += 1;
		}
		$scope.minus = function() {
			if ($scope.addQty === 1) {
				$scope.addQty = 1
				return;
			}
			$scope.addQty -= 1;
		}
		$scope.rewardPoints = function(a) {
			return Math.round(priceCal(a / 100) * theme.prx.llPoints)
		};
		$scope.size = theme.product.variants[0].option1.replace('Default Title', '');
		$scope.selectVariant = function(v) {
			$scope.variants.forEach((item) => {
				if (item.id == v) {
					$scope.selectedVariant = item;
					$scope.selectedPrice = $scope.selectedVariant.price;
					$scope.available = $scope.selectedVariant.available;
					$scope.size = item.option1;
				}
			});
		}
		$scope.selectPurchaseType = function(t) {
			if (t == "0") {
				$scope.singlePurchaseSelected = true;
				$scope.subscribePurchaseSelected = false;
				$scope.selectedPrice = $scope.selectedVariant.price;
				$scope.available = $scope.selectedVariant.available
				$scope.purchaseBtnTxt = "ADD TO CART";
				$('.bold-ro__mixed-radio-btn').attr('checked', false);
				$('.bold-ro__one-time-radio-btn').attr('checked', true);
				$('.bold-ro__one-time-div .bold-ro__recurring-lbl').click();
			} else {
				$scope.subscribePurchaseSelected = true;
				$scope.singlePurchaseSelected = false;
				$scope.selectedPrice = $scope.selectedVariant.price * 0.8;
				$scope.available = $scope.selectedVariant.available
				$scope.purchaseBtnTxt = "SUBSCRIBE";
				$('.bold-ro__one-time-radio-btn').attr('checked', false);
				$('.bold-ro__mixed-radio-btn').attr('checked', true);
				$('.bold-ro__recurring-div .bold-ro__recurring-lbl').click();
				$scope.subQty = $scope.addQty;
				if ($scope.addQty > 6) {
					$scope.addQty = 6;
				}
			}
		}
		$scope.selectedOption = function(v) {
			if ($scope.selectedVariant.id == v) {
				return "selected";
			} else {
				return "";
			}
		}
		$scope.oosVisibility = function(vx) {
			var selectedItem = $scope.selectedVariant.id;
			if (selectedItem == vx) {
				return true;
			}
			return false;
		}
		$scope.addToCart = function() {
			var sands = $scope.subscribePurchaseSelected;
			$scope.variantSelected = $scope.selectedVariant.id
			$scope.optionName = $scope.selectedVariant.option1;
			$scope.optionFav = $scope.selectedVariant.option2;
			var dataString = $('#product_form_' + theme.product.id).serialize();
			fetch("/cart?view=custom-json").then(response => response.json()) // Directly parse JSON
				.then(async (q) => {
					var basketQty = q.item_count;
					if (basketQty + $scope.addQty > 24) {
						alert('You can only have up to 24 items in your basket. Please adjust the quantity.');
						return;
					} else {
						$.ajax({
							type: "POST",
							url: "/cart/add",
							data: dataString,
							success: function() {
								$('.open-mini-cart').click();
							}
						});
						return;
					}
				});
		}

		function _switchVariant(v) {
			$scope.variants.forEach((item) => {
				if (item.id == v) {
					$scope.selectedVariant = item;
					$scope.selectedPrice = $scope.selectedVariant.price;
					$scope.available = $scope.selectedVariant.available
					$scope.size = item.option1;
				}
			});
		}
		var url = window.location.href;
		if (url.includes('variant')) {
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach((r) => {
				var key = r.split('=');
				if (key[0] === 'variant') {
					_switchVariant(key[1])
				}
			});
		}
	}]);
	app.controller('alsoPurchasedCtr', ['$scope', '$http', function($scope, $http) {
		$http.get("/recommendations/products.json?product_id=" + theme.product.id).then((res) => {
			$scope.items = res.data.products;
		});
	}]);
	window.onresize = function() {
		if (window.innerWidth < 768) {
			var a = $('.prx_inside');
			var b = $('.prx-topic-icon')
			b.appendTo(a);
		} else {
			var a = $('.prx-main-image-wrapper');
			var b = $('.prx-topic-icon')
			b.appendTo(a);
		}
	}
	if (window.innerWidth < 768) {
		var a = $('.prx_inside');
		var b = $('.prx-topic-icon')
		b.appendTo(a);
	}
	$('.formula_tab').click(function() {
		var currentSection = $(this).data('sector');
		var $selected = $('#' + currentSection);
		if ($selected.hasClass('open-tab')) {
			$selected.removeClass('open-tab');
			$(this).removeClass('open');
		} else {
			$selected.addClass('open-tab');
			$(this).addClass('open')
		}
	});
	$('.info-tab').click(function() {
		var currentSection = $(this).data('section');
		var s = `.${currentSection}_inside`;
		if ($(s).hasClass('open-section')) {
			$(s).removeClass('open-section');
			$(this).removeClass('tab-opened')
		} else {
			$(s).addClass('open-section');
			$(this).addClass('tab-opened')
		}
	});
	$('.prx-faq_question').on('click', function() {
		var currentSection = $(this).data('section');
		var target = $('#' + currentSection);
		if (target.hasClass('show-answer')) {
			target.removeClass('show-answer');
			$(this).removeClass('question-selected');
		} else {
			target.addClass('show-answer');
			$(this).addClass('question-selected');
		}
	});
	var mfaq = false;
	$('.prx-faq-view-more').click(function() {
		if (mfaq) {
			$(this).html('View More Questions');
			mfaq = false;
			$('.show-question').each(function() {
				$(this).addClass('hide-question');
				$(this).removeClass('show-question');
			});
		} else {
			$(this).html('View Less Questions');
			mfaq = true;
			$('.hide-question').each(function() {
				$(this).removeClass('hide-question');
				$(this).addClass('show-question');
			});
		}
	});
})();
$(function() {
	$('.ex_icons').slick({
		arrows: true,
		mobileFirst: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		row: 2,
		responsive: [{
			breakpoint: 768 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				centerMode: false,
				slidesToShow: 4,
				rows: 1,
				dots: false
			},
		}, {
			breakpoint: 1024 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false,
				rows: 1,
				arrows: true
			},
		}, {
			breakpoint: 1240 - 1,
			settings: {
				arrows: true,
				slidesToScroll: 4,
				slidesToShow: 4,
				centerMode: false,
				rows: 1,
				arrows: true
			},
		}, ]
	});
})